export const deviceTemplates = {
  ventilator: {
    name: 'Ventilator',
    icon: 'vent',
    inputs: [
      { key: 'mode', label: 'Mode', type: 'select', options: ['AC', 'SIMV', 'NPPV', 'APRV', 'PRVC'] },
      { key: 'rate', label: 'Rate', type: 'number', unit: 'bpm' },
      { key: 'tidalVolume', label: 'Vt', type: 'number', unit: 'mL' },
      { key: 'peep', label: 'PEEP', type: 'number', unit: 'cmH\u2082O' },
      { key: 'iTime', label: 'i-Time', type: 'number', unit: 'sec' },
      { key: 'fio2', label: 'FiO\u2082', type: 'number', unit: '%', min: 21, max: 100 },
      { key: 'sensitivity', label: 'Sensitivity', type: 'number' },
      { key: 'pressureSupport', label: 'PS', type: 'number', unit: 'cmH\u2082O' },
      { key: 'pressureControl', label: 'PC', type: 'number', unit: 'cmH\u2082O' },
    ],
    measurements: [
      { key: 'vte', label: 'Vte', unit: 'mL' },
      { key: 've', label: 'Ve', unit: 'L/min' },
      { key: 'pip', label: 'PIP', unit: 'cmH\u2082O' },
      { key: 'pplat', label: 'pPlat', unit: 'cmH\u2082O' },
      { key: 'map', label: 'MAP', unit: 'cmH\u2082O' },
      { key: 'peepMeasured', label: 'PEEP', unit: 'cmH\u2082O' },
      { key: 'autoPeep', label: 'Auto-PEEP', unit: 'cmH\u2082O' },
      { key: 'ieRatio', label: 'i:e', type: 'text' },
      { key: 'f', label: 'f', unit: 'bpm' },
      { key: 'etco2', label: 'ETCO\u2082', unit: 'mmHg' },
    ],
  },
  nppv: {
    name: 'NPPV',
    icon: 'nppv',
    inputs: [
      { key: 'mode', label: 'Mode', type: 'select', options: ['CPAP', 'BiPAP'] },
      { key: 'ipap', label: 'IPAP', type: 'number', unit: 'cmH\u2082O' },
      { key: 'epap', label: 'EPAP', type: 'number', unit: 'cmH\u2082O' },
      { key: 'rate', label: 'Rate', type: 'number', unit: 'bpm' },
      { key: 'fio2', label: 'FiO\u2082', type: 'number', unit: '%', min: 21, max: 100 },
    ],
    measurements: [
      { key: 'vte', label: 'Vte', unit: 'mL' },
      { key: 've', label: 'Ve', unit: 'L/min' },
      { key: 'pip', label: 'PIP', unit: 'cmH\u2082O' },
      { key: 'leakRate', label: 'Leak Rate', unit: 'L/min' },
      { key: 'etco2', label: 'ETCO\u2082', unit: 'mmHg' },
    ],
  },
  iabp: {
    name: 'IABP',
    icon: 'iabp',
    inputs: [
      { key: 'ratio', label: 'Augmentation Ratio', type: 'select', options: ['1:1', '1:2', '1:3'] },
      { key: 'timing', label: 'Timing', type: 'select', options: ['Auto', 'Semi-Auto', 'Manual'] },
      { key: 'gasVolume', label: 'Gas Volume', type: 'number', unit: 'cc' },
      { key: 'triggerMode', label: 'Trigger', type: 'select', options: ['ECG', 'Pressure', 'Internal'] },
    ],
    measurements: [
      { key: 'augmentedDiastolic', label: 'Augmented Diastolic', unit: 'mmHg' },
      { key: 'unassistedSystolic', label: 'Unassisted Systolic', unit: 'mmHg' },
      { key: 'assistedSystolic', label: 'Assisted Systolic', unit: 'mmHg' },
      { key: 'meanPressure', label: 'Mean Pressure', unit: 'mmHg' },
      { key: 'heartRate', label: 'Heart Rate', unit: 'bpm' },
    ],
  },
  abp: {
    name: 'ABP',
    icon: 'abp',
    inputs: [
      { key: 'site', label: 'Insertion Site', type: 'select', options: ['Radial', 'Femoral', 'Brachial', 'Dorsalis Pedis'] },
      { key: 'zeroed', label: 'Zeroed', type: 'select', options: ['Yes', 'No'] },
      { key: 'transducerLevel', label: 'Transducer Level', type: 'select', options: ['Phlebostatic Axis', 'Other'] },
    ],
    measurements: [
      { key: 'systolic', label: 'Systolic', unit: 'mmHg' },
      { key: 'diastolic', label: 'Diastolic', unit: 'mmHg' },
      { key: 'map', label: 'MAP', unit: 'mmHg' },
      { key: 'heartRate', label: 'Heart Rate', unit: 'bpm' },
    ],
  },
  venousPacer: {
    name: 'Venous Pacer',
    icon: 'pacer',
    inputs: [
      { key: 'mode', label: 'Mode', type: 'select', options: ['VVI', 'VOO', 'DDD', 'DOO', 'AAI'] },
      { key: 'rate', label: 'Rate', type: 'number', unit: 'bpm' },
      { key: 'output', label: 'Output', type: 'number', unit: 'mA' },
      { key: 'sensitivity', label: 'Sensitivity', type: 'number', unit: 'mV' },
    ],
    measurements: [
      { key: 'captureThreshold', label: 'Capture Threshold', unit: 'mA' },
      { key: 'sensingThreshold', label: 'Sensing Threshold', unit: 'mV' },
      { key: 'impedance', label: 'Impedance', unit: 'ohms' },
      { key: 'heartRate', label: 'Heart Rate', unit: 'bpm' },
    ],
  },
};

export function getDeviceTemplate(deviceType) {
  return deviceTemplates[deviceType] || null;
}

export function getDeviceTypeList() {
  return Object.entries(deviceTemplates).map(([key, val]) => ({
    key,
    name: val.name,
    icon: val.icon,
  }));
}
